export const COMPONENT_LEAD = 'COMPONENT_LEAD' as const;
export const PROJECT_DEFAULT = 'PROJECT_DEFAULT' as const;
export const PROJECT_LEAD = 'PROJECT_LEAD' as const;
export const UNASSIGNED = 'UNASSIGNED' as const;
